import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoaderService } from 'src/app/loader.service';
import { UserTypes } from 'src/app/shared/interfaces/userType.model';
import { RfidServiceService } from 'src/app/_service/rfid-service.service';
import { UserService } from 'src/app/_services';

@Component({
  selector: 'telio-rfid-user',
  templateUrl: './rfid-user.component.html',
  styleUrls: ['./rfid-user.component.scss']
})
export class RfidUserComponent implements OnInit {

  mobileNumber;
  userDetails;

  constructor(private rfidService: RfidServiceService,
    public loaderService: LoaderService,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.mobileNumber = params.mobile;
    });
    this.userService.getAllUsers(1, 10, 'username', 'asc', this.mobileNumber, UserTypes.mobileUsers).subscribe(
      resp => {
        this.userDetails = resp.data.content[0];
        if (this.userDetails.user.email == "" || !this.userDetails.user.email) {
          this.userDetails.user.email = "NA"
        }
      }
    )
  }
  
  topback() {
    this.router.navigate(['/dashboard/rfid', { routeID: this.route.snapshot.paramMap.get('routeID') }])
  }
}
